export default "__VITE_ASSET__DeYYSo36__"